import { socialApi } from './shared';

/** Hand-authored TikTok endpoint copy and examples. */
export const TIKTOK = socialApi({
  id: 'tiktok',
  name: 'TikTok',
  blurb:
    'Profiles, videos and transcripts from TikTok as clean, normalized JSON: call one endpoint with a handle or URL, pay in real dollars, no tokens or rate limits to manage.',
  endpoints: {
    profile: {
      description: 'Full public profile for a handle: display name, bio, avatar, follower and like counts.',
      input: { handle: 'cristiano' },
      sample: {
        handle: 'cristiano',
        displayName: 'Cristiano Ronaldo',
        bio: 'SIUUU 🇵🇹',
        verified: true,
        followers: 64_200_000,
        following: 12,
        likes: 412_000_000,
        videos: 38,
        avatarUrl: 'https://p16.tiktokcdn.com/cristiano.jpg',
      },
    },
    profile_videos: {
      description: 'Paginated feed of a creator’s videos with stats, captions and media URLs. Paginate with the cursor field.',
      input: { handle: 'cristiano', cursor: '0' },
      sample: {
        nextCursor: '1718200000000',
        videos: [
          {
            id: '7375000000000000000',
            url: 'https://www.tiktok.com/@cristiano/video/7375000000000000000',
            caption: 'Matchday 🔥',
            views: 9_400_000,
            likes: 1_200_000,
            comments: 18_400,
            shares: 64_000,
            createdAt: '2024-06-10T18:20:00Z',
          },
        ],
      },
    },
    video_transcript: {
      description: 'Spoken-word transcript for a single video by URL, with timestamps where available.',
      input: { url: 'https://www.tiktok.com/@cristiano/video/7375000000000000000' },
      sample: {
        url: 'https://www.tiktok.com/@cristiano/video/7375000000000000000',
        language: 'en',
        transcript: 'Today is matchday and we are ready to give everything for the win.',
      },
    },
    search_keyword: {
      action: 'Keyword search',
      description: 'Search TikTok by keyword and get matching videos with captions and engagement (views, likes, comments, shares).',
      input: { query: 'marathon training' },
      sample: {
        videos: [
          {
            id: '7268287584244124971',
            caption: 'My marathon training routine 🏃',
            region: 'US',
            views: 1_282_645,
            likes: 481_608,
            comments: 187,
            shares: 2_721,
          },
        ],
      },
    },
    video: {
      description: 'Full detail for a single TikTok video by URL: caption, region and engagement counts (views, likes, comments, shares, saves).',
      input: { url: 'https://www.tiktok.com/@cristiano/video/7375000000000000000' },
      sample: {
        id: '7375000000000000000',
        caption: 'Matchday 🔥',
        region: 'US',
        views: 9_400_000,
        likes: 1_200_000,
        comments: 18_400,
        shares: 64_000,
        saves: 41_200,
      },
    },
    video_comments: {
      description: 'List the comments on a video by URL with cursor pagination: text, author, likes and reply count.',
      input: { url: 'https://www.tiktok.com/@cristiano/video/7375000000000000000' },
      sample: {
        nextCursor: '20',
        comments: [
          {
            id: '7517114944362499999',
            text: 'GOAT 🐐',
            author: 'footyfan',
            likes: 1_240,
            replies: 12,
            createdAt: 1_718_200_000,
          },
        ],
      },
    },
    search_users: {
      action: 'User search',
      description: 'Search TikTok accounts by keyword with cursor pagination: handle, nickname and follower count.',
      input: { query: 'cristiano' },
      sample: {
        nextCursor: '30',
        users: [
          {
            handle: 'cristiano',
            nickname: 'Cristiano Ronaldo',
            userId: '6757029651601835013',
            followers: 64_200_000,
            following: 12,
          },
        ],
      },
    },
  },
});
